// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1-1t0","checkboxCol":"Table_checkboxCol__2tfi4","emailCol":"Table_emailCol__eLd3A","actionCol":"Table_actionCol__QpCWm"};